import { render, staticRenderFns } from "./CabinetRentalService.vue?vue&type=template&id=54ab26c9&"
import script from "./CabinetRentalService.vue?vue&type=script&lang=js&"
export * from "./CabinetRentalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports